import { useState, useContext, useEffect } from "react"
import { Button, Card, Col, Form, Row, OverlayTrigger, Tooltip, Modal } from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { HiOutlineTrash } from "react-icons/hi"
import { Field, Formik } from "formik"
import Select from 'react-select';
import * as Yup from 'yup';
import { useHistory } from "react-router-dom"

import Get from '../../api/Get'
import Post from '../../api/Post'
import Put from '../../api/Put'
import {
    ESPECIALITIES_ALL,
    DOCTOR_GET,
    DOCTOR_ADD,
    DOCTOR_UPDATE,
    PROVIDER_LIST_ACTIVE,
    COUNTRY_ACTIVE_ALL,
} from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import { UploadImage } from "./UploadImage"
import { withTranslation } from "react-i18next"
import { isBase64 } from "../../utils/isBase64"

import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'
import { toast } from "react-toastify"
import ComponentModalErrorSever from "../ComponentModalErrorSever"
import SelectEstado from "../SelectEstado"
import { add } from "lodash"

function FormDoctor({ t, id }) {
    const { auth } = useContext(authContext)
    const history = useHistory();
    const [gender, setGender] = useState('Female')
    const [loading, setLoading] = useState(false)
    const [licenceSpeciality, setLicenceSpeciality] = useState([])
    const [showModalEspeciality, setShowModalEspeciality] = useState(false)
    const [specialityOpt, setSpecialityOpt] = useState([])//Para la lista de selección
    const curpRegExp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/g
    const [phone, setPhone] = useState('')
    const [providerOpt, setProviderOpt] = useState([])
    const [proveedorDefault, setProveedorDefault] = useState(null)
    const [countryOpt, setCountryOpt] = useState([]);
    const [paisDefault, setPaisDefault] = useState([]);
    const [idCountry, setIdCountry] = useState(null);
    const [address, setAddress] = useState('');

    const [initialValues, setInitialValues] = useState({
        name: '',
        lastName: '',
        segundoApellidoPrestador: '',
        phone: '',
        email: '',
        gender: 'Female',
        curp: '',
        licenceSpeciality: [],
        bank: '',
        accountNumber: '',
        public_price: '',
        password: '',
        providerService: '',
        url_photo: '',
        url_signature: '',
        company: auth.data.company,
        esConsultorio: false,
        address: '',
    })

    const shemaValidate = id ? Yup.object().shape({
        name: Yup.string().required(t('Camporequerido')),
        lastName: Yup.string().required(t('Camporequerido')),
        segundoApellidoPrestador: Yup.string().required(t('Camporequerido')),
        phone: Yup.string().required(t('Camporequerido')),
        email: Yup.string().required(t('Camporequerido')).email('Correo electrónico inválido'),
        gender: Yup.string().required(t('Camporequerido')),
        curp: Yup.string().required(t('Camporequerido')).matches(curpRegExp, "La CURP no es válida"),
        providerService: Yup.string().required(t('Camporequerido'))
    }) : Yup.object().shape({
        name: Yup.string().required(t('Camporequerido')),
        lastName: Yup.string().required(t('Camporequerido')),
        segundoApellidoPrestador: Yup.string().required(t('Camporequerido')),
        phone: Yup.string().required(t('Camporequerido')),
        email: Yup.string().required(t('Camporequerido')).email('Correo electrónico inválido'),
        gender: Yup.string().required(t('Camporequerido')),
        curp: Yup.string().required(t('Camporequerido')).matches(curpRegExp, "La CURP no es válida"),
        password: Yup.string().required(t('Camporequerido')),
        providerService: Yup.string().required(t('Camporequerido')),
    });

    const [speciality, setSpeciality] = useState({
        "idSpeciality": '',
        "speciality": '',
        "licence": '',
        "formationPlace": ''
    })

    const specialityValidate = Yup.object().shape({
        speciality: Yup.string().required('Campo Requerido'),
        licence: Yup.string().required('Campo Requerido'),
        formationPlace: Yup.string().required('Campo Requerido')
    });


    const accesToken = auth.data.access_token

    //GEt Lista de especialidades
    useEffect(() => {
        Get({ url: ESPECIALITIES_ALL, access_token: accesToken })
            .then(resp => {
                let data = resp.data.data.response
                let opt = []

                data.map((d) => {
                    opt.push({ value: `${d.id}`, label: `${d.name}` })
                });

                setSpecialityOpt(opt)
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })

        Get({ url: PROVIDER_LIST_ACTIVE, access_token: accesToken })
            .then(resp => {
                setProviderOpt(resp?.data.data.response.map(el => ({ value: el.id, label: el.name })))
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })
    }, [])

    //Obtener Paises
    useEffect(() => {
        Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
            .then((response) => {
                setCountryOpt(
                    response.data.data.response.map((el) => ({
                        label: el.name,
                        value: el.id,
                    }))
                );
            })
            .catch((error) => {
                //setShowModalError(true);
                if (error.response) {
                    setError(error.response)
                }
            });
    }, []);



    //Para obtener la información del doctor
    useEffect(() => {
        if (id) {
            setLoading(true)

            Get({ url: `${DOCTOR_GET}/${id}`, access_token: accesToken })
                .then(resp => {
                    //console.log(resp)
                    let data = resp.data.data
                    let espDefault = []

                    data.licenceSpeciality.map(es => {
                        let def = specialityOpt.filter(opc => opc.value == es.idSpeciality)
                        espDefault.push(def[0])
                    })

                    setLicenceSpeciality(data?.licenceSpeciality ?? [])

                    let infoDoctor = {
                        name: data.name ?? '',
                        lastName: data.lastName ?? '',
                        segundoApellidoPrestador: data.segundoApellidoPrestador ?? '',
                        phone: data.phone ?? '',
                        email: data.email ?? '',
                        gender: data.gender ?? 'Female',
                        curp: data.curp ?? '',
                        licenceSpeciality: data.licenceSpeciality ?? [],
                        password: data?.password ?? '',
                        providerService: data?.providerService?.id ?? '',
                        url_photo: data.url_photo ? data.url_photo : '',
                        url_signature: data.url_signature ?? '',
                        company: initialValues.company,
                        esConsultorio: data.esConsultorio,
                        address: data.address ?? '',
                    }
                    console.log(data)
                    setPhone(data.phone)
                    setProveedorDefault({ value: data.providerService?.id, label: data.providerService?.name })
                    setGender(data?.gender ?? 'Female')
                    setInitialValues(infoDoctor)
                    setLoading(false)
                    setIdCountry(data.paisNacimiento);
                    /*setPaisDefault({
                        label: data.paisNacimiento.name,
                        value: data.paisNacimiento.id,
                    });*/
                })
                .catch(error => {
                    console.log("error al cargar las especialidades ", error)
                    setLoading(false)
                })
        }
    }, [])

    //Crear label y value de default

    useEffect(() => {
        if (idCountry && countryOpt.length > 0) {
            const selectedCountry = countryOpt.find(option => option.value == idCountry);
            setPaisDefault(selectedCountry ? { value: selectedCountry.value, label: selectedCountry.label } : { value: 'Undefined', label: 'Undefined' });
            console.log('país',selectedCountry);
        }
    }, [idCountry, countryOpt]);

    //PAra generar la lista de obciones de las especialidades
    useEffect(() => {
        let opt = []
        specialityOpt.map((d) => {
            const enUso = licenceSpeciality.filter(l => l.idSpeciality == d.value)
            opt.push({
                value: `${d.value}`,
                label: `${d.label}`,
                isDisabled: enUso.length > 0
            })
        });
        setSpecialityOpt(opt)
    }, [licenceSpeciality])


    const handleShowModalEspeciality = () => setShowModalEspeciality(true)
    const handleCloseModalEspeciality = () => setShowModalEspeciality(false)

    const deleteEspecialidad = id => {
        const arr = licenceSpeciality.filter(item => item?.idSpeciality !== id)
        setLicenceSpeciality(arr)
    }

    const [show, setShow] = useState(false)
    const [error, setError] = useState(null)
    const handleClose = () => setShow(false)

    return (<>
        {
            (id && loading) ? <LoadingList /> : <>

                <Formik initialValues={initialValues}
                    validationSchema={shemaValidate}
                    onSubmit={(values, { setSubmitting, setFieldValue }) => {
                        if (licenceSpeciality.length === 0) {
                            toast.warning('Es necesario seleccionar al menos una especialidad')
                            setSubmitting(false)
                            return
                        }
                        const data = JSON.parse(JSON.stringify(values))

                        data.active = true
                        data.licenceSpeciality = licenceSpeciality
                        data.providerService = { id: parseInt(values.providerService) }

                        if (!isBase64(data.url_signature)) {
                            data.url_signature = ""
                        }
                        if (!isBase64(data.url_photo)) {
                            data.url_photo = ""
                        }
                        console.log(data)
                        if (id) {
                            data.id = parseInt(id)
                            Put({ url: DOCTOR_UPDATE, data: data, header: true, access_token: accesToken })
                                .then((resp) => {
                                    setSubmitting(false)
                                    history.goBack()
                                })
                                .catch((error) => {
                                    setSubmitting(false)
                                    setShow(true)
                                    if (error.response) {
                                        setError(error.response)
                                    }
                                })
                        } else {
                            Post({ url: DOCTOR_ADD, data: data, header: true, access_token: accesToken })
                                .then((resp) => {
                                    setSubmitting(false)
                                    history.goBack()
                                })
                                .catch((error) => {
                                    setSubmitting(false)
                                    setShow(true)
                                    if (error.response) {
                                        setError(error.response)
                                    }
                                })
                        }
                    }}
                >{({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setFieldError
                }) => (
                    <Form onSubmit={handleSubmit} className='mt-3'>
                        {isSubmitting && <LoadingList texto="Procesando petición" />}
                        <Row className="justify-content-md-center text-center">
                            <Col xs="6" md="6">
                                <UploadImage title='Foto'
                                    imageDefault={values?.url_photo}
                                    field='url_photo'
                                    setFieldValue={setFieldValue}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Card className="shadow-1">
                            <Card.Body>
                                <h4 className="text-color-4 subtitulo">Datos generales</h4>
                                <Row className='mt-5'>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Nombre</Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.name && 'error'}`}
                                                name="name"
                                            />
                                            {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Apellido Paterno</Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.lastName && 'error'}`}
                                                name="lastName"
                                            />
                                            {errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="4">

                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Apellido Materno</Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.segundoApellidoPrestador && 'error'}`}
                                                name="segundoApellidoPrestador"
                                            />
                                            {errors.segundoApellidoPrestador && <div className="invalid-feedback d-block">{errors.segundoApellidoPrestador}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="3">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Teléfono</Form.Label>
                                            <PhoneInput
                                                inputClass={`form-control input-form ${errors.phone && 'error'} w-100`}
                                                country={'mx'}
                                                countryCodeEditable={false}
                                                enableSearch={true}
                                                preferredCountries={['mx', 'co']}
                                                disableSearchIcon={true}
                                                localization={es}
                                                value={phone}
                                                onChange={(ph, country, e, formattedValue) => {
                                                    setPhone(ph)
                                                    setFieldValue('phone', ph, false)
                                                    let validNumber = (country.format.match(/\./g)).length
                                                    if (ph.length !== validNumber) {
                                                        setFieldError('phone', 'Campo inválido')
                                                    } else if (ph.length === validNumber) {
                                                        setFieldValue('phone', ph, true)
                                                    }
                                                }}
                                            />
                                            {errors.phone && <div className="invalid-feedback d-block">{errors.phone}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="3">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Correo Electrónico</Form.Label>
                                            <Field
                                                type="email"
                                                className={`form-control input-form ${errors.email && 'error'}`}
                                                name="email"
                                            />
                                            {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('compania')} </Form.Label>
                                            <input
                                                className="form-control input-form"
                                                defaultValue={auth.data.company.name}
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Dirección</Form.Label>
                                            <Field  type="text" className={`form-control input-form`} name="address" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Sexo</Form.Label>
                                            <ul className="mb-0 list-inline list-form">
                                                <li className={`${gender === 'Female' && 'active'} list-inline-item cursor-pointer`} onClick={e => {
                                                    setGender('Female')
                                                    setFieldValue('gender', 'Female')
                                                }}>
                                                    <span className="input-radio-custom text-color-input">Femenino</span>
                                                </li>
                                                <li className={`${gender === 'Male' && 'active'} list-inline-item cursor-pointer`} onClick={e => {
                                                    setGender('Male')
                                                    setFieldValue('gender', 'Male')
                                                }}>
                                                    <span className="input-radio-custom text-color-input">Masculino</span>
                                                </li>
                                            </ul>
                                            {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="3">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">
                                                País de Nacimiento
                                            </Form.Label>
                                            <Select
                                                className={`input-form ${errors.country && "error"
                                                    }`}
                                                options={countryOpt}
                                                defaultValue={paisDefault}
                                                value={paisDefault}
                                                onChange={(value) => {
                                                    //console.log(e)
                                                    setPaisDefault(value);
                                                    setFieldValue("paisNacimiento", value.value);
                                                    /*setMunicipioOpt([]);
                                                    setFieldValue("municipio", "");
                                                    setMunicipioDefault(null);
                                                    setFieldValue("state", "");
                                                    setEstadoDefault(null);*/
                                                    setIdCountry(value.value);
                                                }}
                                                placeholder="Escoger opción"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">CURP</Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.curp && 'error'}`}
                                                name="curp"
                                            />
                                            {errors.curp && <div className="invalid-feedback d-block">{errors.curp}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    {!id && <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Password</Form.Label>
                                            <Field
                                                type="password"
                                                className={`form-control input-form ${errors.password && 'error'}`}
                                                name="password"
                                            />
                                            {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                                        </Form.Group>
                                    </Col>}
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Proveedor <span className="text-danger">*</span></Form.Label>
                                            <SelectEstado
                                                defaultValue={proveedorDefault}
                                                url={PROVIDER_LIST_ACTIVE}
                                                value={proveedorDefault}
                                                access_token={auth.data.access_token}
                                                isMulti={false}
                                                handleChange={(value) => {
                                                    setProveedorDefault(value)
                                                    setFieldValue("providerService", value.value)
                                                }}
                                                defaultOptions={providerOpt}
                                                valid={true}
                                                isClearable={false}
                                                className={`input-form ${errors.providerService && 'error'}`}
                                            />
                                            {errors.providerService && <div className="invalid-feedback d-block">{errors.providerService}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <div className="form-check form-check-inline">
                                            <Field
                                                className="form-check-input"
                                                name="esConsultorio"
                                                type="checkbox"
                                            />
                                            <label className="form-check-label">Consultorio</label>
                                        </div>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                        <br />
                        <Row className="justify-content-md-center text-center">
                            <Col xs="6" md="6">
                                <UploadImage title='Firma'
                                    imageDefault={values?.url_signature}
                                    field='url_signature'
                                    setFieldValue={setFieldValue}
                                />
                            </Col>
                        </Row>
                        <br />

                        <Card className="shadow-1 formSection">
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <h4 className="text-color-4 subtitulo">Datos de especialista</h4>
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        <BsPlusCircleFill className="add-btn-middle clicked" onClick={handleShowModalEspeciality} />
                                    </Col>
                                </Row>
                                {
                                    licenceSpeciality.map((licence, l) => <Row key={licence?.idSpeciality}>
                                        <Col>{licence?.speciality}</Col>
                                        <Col>{licence?.licence}</Col>
                                        <Col>{licence?.formationPlace}</Col>
                                        <Col className="d-flex justify-content-end">
                                            <OverlayTrigger key={`EliminarEspecialidad${licence?.idSpeciality}`}
                                                placement='top'
                                                overlay={<Tooltip id={`eliminarEspecialidad${licence?.idSpeciality}`}> Eliminar especialidad </Tooltip>}
                                            >
                                                <HiOutlineTrash className='iconAction colorRojo clicked' onClick={() => deleteEspecialidad(licence?.idSpeciality)} />
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>)
                                }
                            </Card.Body>
                        </Card>

                        <Row className="grupoBotones">
                            <Col className="text-right">
                                <Button variant="danger" className="cancelar-buttom" type="buttom" onClick={e => history.push('/admin/doctors')}>Cancelar</Button>{' '}
                                <Button variant="outline-success" className="ok-buttom" type="submit">{`${id ? 'Editar' : 'Agregar'}`}</Button>{' '}
                            </Col>
                        </Row>
                    </Form>
                )}
                </Formik>

                <Modal show={showModalEspeciality} onHide={handleCloseModalEspeciality} centered className="border-0" backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <Formik initialValues={speciality}
                            validationSchema={specialityValidate}
                            onSubmit={(values, { setSubmitting, setFieldValue }) => {

                                setLicenceSpeciality(l => [...l, values])
                                handleCloseModalEspeciality();

                            }}>{({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue
                            }) => (
                                <Form onSubmit={handleSubmit} className='mt-3'>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Especialidad</Form.Label>
                                                <Select
                                                    className="select-especialista"
                                                    closeMenuOnSelect={true}
                                                    options={specialityOpt}
                                                    onChange={item => {
                                                        setFieldValue('idSpeciality', item?.value)
                                                        setFieldValue('speciality', item?.label)
                                                    }}
                                                />
                                                {errors.speciality && <div className="invalid-feedback d-block">{errors.speciality}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Cédula profesional</Form.Label>
                                                <Field
                                                    type="text"
                                                    className={`form-control input-form ${errors.licence && 'error'}`}
                                                    name="licence"
                                                />
                                                {errors.licence && <div className="invalid-feedback d-block">{errors.licence}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Centro de estudios</Form.Label>
                                                <Field
                                                    type="text"
                                                    className={`form-control input-form ${errors.formationPlace && 'error'}`}
                                                    name="formationPlace"
                                                />
                                                {errors.formationPlace && <div className="invalid-feedback d-block">{errors.formationPlace}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="text-right mt-4">
                                        <Button className="cancel-button px-4" variant="danger" type="submit">Agregar</Button>
                                        <Button variant="link" className="text-secondary no-underline" type="button" onClick={handleCloseModalEspeciality}>Cancelar</Button>
                                    </div>
                                </Form>
                            )}</Formik>
                    </Modal.Body>
                </Modal>
            </>
        }

        <ComponentModalErrorSever show={show} error={error} handleClose={handleClose} />

    </>)

}

export default withTranslation()(FormDoctor)